import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalData } from "../../util/GlobalData";
import { LoaderComponent } from "../../util/Loader";
import { formatDate, formatLongNumber, isAdminAccount } from "../../util/Global";
import Pagination from "../Pagination";
import { CurrencyContext } from "../Utils";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Paper,
    Tooltip,
    IconButton,
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';




export default function OrderSaleList({ items, isOrder, isSale }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(true);
    const [currentItems, setcurrentItems] = useState([]);
    const [paginatedItems, setpaginatedItems] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    useEffect(() => {
        if (items) {
            setcurrentItems(items);
            setisLoading(false);
        }
    }, [items]);

    const handleSort = (key) => {
        const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
        setSortConfig({ key, direction });

        const sortedItems = [...currentItems].sort((a, b) => {
            if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
            if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setcurrentItems(sortedItems);
    };

    return (
        <LoaderComponent isLoading={isLoading}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {[
                                { key: "reference", label: t("reference") },
                                { key: "methode_de_paiement", label: t("paymentMethod") },
                                { key: "created_at", label: t("createdAt") },
                                { key: "currency", label: t("paymentCurrency") },
                                { key: "totale", label: t("total") },
                                { key: "statut_commande", label: t("paymentStatus") },
                                { key: "details", label: t("details"), isSortable: false },
                            ].map(({ key, label, isSortable = true }) => (
                                <TableCell key={key}>
                                    {isSortable ? (
                                        <TableSortLabel
                                            active={sortConfig.key === key}
                                            direction={sortConfig.key === key ? sortConfig.direction : "asc"}
                                            onClick={() => handleSort(key)}
                                        >
                                            {label}
                                        </TableSortLabel>
                                    ) : (
                                        label
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedItems != null &&
                            paginatedItems.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.reference}</TableCell>
                                    <TableCell>{t("paymentMethods."+item.methode_de_paiement)}</TableCell>
                                    <TableCell>{formatDate(item.created_at)}</TableCell>
                                    <TableCell>{item.currency}</TableCell>
                                    <TableCell>
                                        {GlobalData.currency[item.currency]} {formatLongNumber((item.totale))}
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            backgroundColor:
                                                item.statut_commande === "pending" ? "orange"
                                                    : item.statut_commande === "refund" ? "blue"
                                                        : item.statut_commande === "paid" ? "green"
                                                            : item.statut_commande === "cancel" ? "red"
                                                                : "transparent",
                                            color: "white",
                                            borderColor: item.statut_commande,
                                        }}
                                    >
                                        {t("salesOrders.statusOrder." + item.statut_commande)}
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title={t("view")}>
                                            <IconButton
                                                color="info"
                                                onClick={() => {
                                                    if (isAdminAccount()) {
                                                        navigate("/dashboard/admin/orderDetails/" + item.id);
                                                    }
                                                    else if (isOrder) {
                                                        navigate("/dashboard/user/commandDetails/" + item.id);
                                                    }
                                                    else if (isSale) {
                                                        navigate("/dashboard/user/detailVentes/" + item.id);
                                                    }
                                                }}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <Pagination itemsPerPage={6} items={currentItems} setItems={setpaginatedItems} />
            </TableContainer>
        </LoaderComponent>
    );
}
